import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DayboardDateService {

  dateChanged$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  toDoCall$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  loadRecurringOrder$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  dayboardDate = new Subject<any>();
  headerCollapesed$: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  setDayboardDate$ = new Subject<Date>();


  refreshBt$= new Subject<any>();
  constructor() { }
}
